/* eslint-disable import/no-anonymous-default-export */
const key = 'jwt_os';

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export default {
  getToken() {
    return localStorage.getItem(key);
  },
  setToken(token) {
    localStorage.setItem(key, token);
  },
  clearToken() {
    localStorage.removeItem(key);
  },
  getParsedToken() {
    const token = this.getToken();

    if (!token) {
      return null;
    }

    return parseJwt(token);
  }
};
